// Docs: https://www.npmjs.com/package/role-acl

import { useRouter } from "next/router";
import { AccessControl, Permission } from "role-acl";

import { useAuth } from "@/lib/useAuth";
export { Permission } from "role-acl";

const ac = new AccessControl();

ac.grant("role:sa").execute("view").on("/users/dashboard");
ac.grant("role:sa").execute("view").on("/tools/task-management");
ac.grant("role:pa").execute("view").on("/users/dashboard");
ac.grant("role:pe");

export const accessControl = ac;

export default ac;

export const useUiGrantAccess = (
  resourceName: string,
  options?: { onDenyRedirectTo: string },
) => {
  const { user } = useAuth();

  if (!user?.role?.code) return undefined;
  let permission;
  try {
    permission = accessControl
      .can("role:" + user?.role?.code)
      .execute("view")
      .sync()
      .on(resourceName) as Permission;
  } catch (e) {
    if (process.env.NODE_ENV?.startsWith("dev")) {
      console.error(e);
    }
  }

  if (!permission?.granted && options?.onDenyRedirectTo) {
    const router = useRouter();

    router.replace(options.onDenyRedirectTo).then();
  }

  return permission?.granted;
};
